import { useEffect, useState } from 'react';
import { StarRvDeal } from '@/hooks/useStarRvDeals';
import { useObeUrl } from '@/lib/useObeUrl';
import { AnimatePresence, m as motion } from 'framer-motion';
import Link from 'next/link';

const SCROLL_DELAY_MS = 5000;

export const DealsBanner = ({ deals }: { deals: StarRvDeal[] }) => {
    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);
    const obeUrl = useObeUrl();

    useEffect(() => {
        if (paused || deals.length < 2) {
            return;
        }
        const timeout = setTimeout(() => setIndex((prev) => (prev + 1) % deals.length), SCROLL_DELAY_MS);
        return () => clearTimeout(timeout);
    }, [deals.length, index, paused]);

    const deal = deals[index % deals.length];
    if (deal.code) {
        obeUrl.searchParams.set('promoCode', deal.code);
    }
    const href = deal.marketingUrl || obeUrl.href;

    return (
        <div className="pointer-events-auto flex items-center h-12 lg:h-10 px-4 bg-[#7A939C] text-white overflow-hidden">
            <AnimatePresence mode="popLayout" initial={false}>
                <motion.div
                    key={deal.id}
                    className="flex w-full lg:justify-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.5 }}
                    onHoverStart={() => setPaused(true)}
                    onHoverEnd={() => setPaused(false)}
                >
                    <Link
                        href={href}
                        passHref
                        prefetch={false}
                        className="group flex flex-col items-start gap-1 lg:flex-row lg:items-center lg:gap-3 text-xs lg:text-sm font-bold leading-tight"
                    >
                        {deal.badgeText ? <span className="rounded bg-[#1B365D] px-1.5 py-0.5 text-[10px] uppercase">{deal.badgeText}</span> : null}
                        <span className="line-clamp-1 underline">
                            {deal.title}
                            <span aria-hidden className="lg:hidden">
                                {' →'}
                            </span>
                        </span>
                        {deal.marketingUrl ? <span className="hidden lg:inline-flex rounded-full bg-white px-4 py-1.5 text-xs text-primary shadow">Learn more</span> : null}
                    </Link>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};
